import {mapKeys, isArray} from 'lodash'
import filterErrors from './filterErrors'
import showToastr from './showToastr'

export default class ErrorHandler {
  constructor (e) {
    this.origin = e
    this.message = {status: '', context: ''}
    this.errors = null
    this.code = e.response.status

    switch (e.response.status) {
      case 422:
        const {message, errors} = filterErrors(e.response.data.errors)
        this.errors = errors
        this.message = message.status ? message : {status: 'danger', context: 'خطایی در اطلاعات درج شده وجود دارد'}
        break

      case 401:
        this.message = {status: 'danger', context: e.response.errors._errors[0]}
        break

      case 405:
        this.message = {status: 'danger', context: e.response.errors}
        break

      default:
        this.message = {status: 'danger', context: 'خطایی پیش آمده است، لطفا به پشتیبانی مراجعه نمایید'}
        break
    }
  }

  showToastrIn (title = '') {
    showToastr('error', title, this.message.context)
  }

  setFormErrors (formRef) {
    formRef.state.errors = this.errors
    formRef.setAllTouched()
  }

  getMessage () {
    return this.message
  }

  filterErrors (err) {
    let state = {message: {}, errors: {}}

    if (isArray(err)) {
      state.message = {status: 'danger', context: err[0]}
      return state
    }

    mapKeys(err, (value, key) => {
      if (key === '_errors') {
        state.message = {status: 'danger', context: value[0]}
      } else {
        state.errors[key] = value[0]
      }
    })
    return state
  }
}



// WEBPACK FOOTER //
// ./src/utils/ErrorHandler.js